import Clipboard from 'clipboard';
import * as angular from 'angular';
import { getUrlParam } from './getUrlParam';
import { passwordGrade } from '../../../../../../util/password-strength';
import { base32tohex } from '../../../../../../util/base32-helper';

export class Controller {

    /** @ngInject */
    constructor($state, $scope ,Alert, ConfirmDeleteModal, SharedAccountsService, ConfirmConvertModal, ConfirmModal) {
        this.Alert = Alert;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.ConfirmModal = ConfirmModal;
        this.SharedAccountsService = SharedAccountsService;
        this.$state=$state;
        this.$scope=$scope;
        this.ConfirmConvertModal=ConfirmConvertModal;
    }

    $onInit() {
        this.tooltipTemplate = require('../../secret-tooltip.html');
        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(() => {
            this.Alert('success', 'global.data_copied')
            })
        })

	if (Object.keys(this.sharedAccount).length === 0) {
                this.$state.go('^');
    	}
        const url = this.sharedAccount.publicServiceKey;//this.resolve.account.publicServiceKey;

        this.$account = {
            ...this.sharedAccount,
            digits: +getUrlParam(url, 'digits', 6),
            algorithm: getUrlParam(url, 'algorithm', 'SHA1'),
            secret: getUrlParam(url, 'secret'),
        };

        this.account = {...this.$account};
        this.resetHexSecret();
        this.passGrade=passwordGrade(this.account.password);
        this.publicServicesWithSso$.get().then(items => this.publicServices=items);
        this.searchItem = this.account.publicService.serviceName !== 'Other' ? this.account.publicService.serviceName : 'Custom';
        this.isCustom = this.$account.publicService.slug == 'other';
    }

    saveIcon(iconFile) {
        const formData = new FormData();
        formData.append('iconFile', iconFile);
        return this.SharedAccountsService.uploadCustomIconForCorporateServiceAccount(
            {
                companyId: this.companyId, //resolve.companyId,
                corporateServiceAccountId: this.account.id,
            },
            formData
        )
            .$promise
            .then((data) => {
                this.account.customIcon = data.customIcon;
                this.Alert('success', 'company.sharing-center.manage.saved');
            });
    }

    resetIcon() {

        return this.ConfirmModal({
            messageKey:'Custom icon will be deleted and default icon will be used. Do you want to continue?',
            titleKey:'Confirm Delete'
        })
        .then(() =>
            this.SharedAccountsService.deleteCustomIconForCorporateServiceAccount(
                    {
                        companyId: this.companyId, //resolve.companyId,
                        corporateServiceAccountId: this.account.id,
                    }
                )
                .$promise
                .then(() => {
                    this.account.customIcon = null;
                    this.Alert('success', 'company.sharing-center.manage.saved');
                })
        )
    }

    createCopy() {
        const url = this.sharedAccount.publicServiceKey;
        let copyAccount = {
            username: this.sharedAccount.username,
            password: this.sharedAccount.password,
            note: this.sharedAccount.note,
            showOtpEnabled: this.sharedAccount.showOtpEnabled,
            showPasswordEnabled: this.sharedAccount.showPasswordEnabled,
            showNoteEnabled: this.sharedAccount.showNoteEnabled,
            publicService: this.publicServices.find(i => i.slug === "other"),
            customServiceName: this.getCopyServiceName(),
            algorithm: getUrlParam(url, 'algorithm', 'SHA1'),
            digits: +getUrlParam(url, 'digits', 6),
            secret: getUrlParam(url, 'secret'),
            serviceLoginUrl: this.sharedAccount.publicService.slug === 'other' ? this.sharedAccount.serviceLoginUrl : this.sharedAccount.publicService.serviceUrl
        };
        this.$state.go("company.sharing-center.add-shared-authenticator",{copyAccount:copyAccount});
    }

    getCopyServiceName() {
        let currentServiceName = this.sharedAccount.publicService.slug === 'other' ? this.sharedAccount.customServiceName : this.sharedAccount.publicService.serviceName;
        let customServiceNames = this.allAccounts.filter(account => account.username === this.sharedAccount.username && account.publicService.slug === 'other' && account.customServiceName != null).map(item => {
            return item.customServiceName;
        });
        currentServiceName = currentServiceName.indexOf(' Copy') !== -1 ? currentServiceName.substring(0, currentServiceName.indexOf(' Copy')) : currentServiceName;
        let copyServiceName = currentServiceName + ' Copy';
        if (customServiceNames.indexOf(copyServiceName) === -1) {
            return copyServiceName;
        }
        
        let i = 1;
        while (customServiceNames.indexOf(copyServiceName + ' ' + i) !== -1) {
            i++;
        }
        return copyServiceName + ' ' + i;
    }
    
    changePassGrade(){
		this.passGrade=passwordGrade(this.account.password);
	}

    notModified() {
        if (this.$account.publicService.id === this.account.publicService.id) {
            this.account.publicService = this.$account.publicService;
        }
        return angular.equals(this.$account, this.account);
    }

    selectCustom() {
        this.searchItem = 'Custom';
        this.account.publicService = this.publicServices.find(i => i.slug === "other");
    }

    serviceSelected(service) {
        this.account.publicService = service;
        if (service.slug !== "other") {
            this.account.customServiceName = null;
        }
    }

    resetHexSecret() {
        this.hexSecret = this.convertHex(this.account.secret);
    }

    convertHex(value) {
        if (value == null || value.length == 0)
            return value;
        return base32tohex(value);
    }

    remove() {
        this.isRemoving = true;
        this.ConfirmDeleteModal('groups_users.confirm_company_user_account_delete')
            .then(() => this.SharedAccountsService.deleteCompanyServiceAccounts({
                companyId: this.companyId, //resolve.companyId,
                id: this.account.id,
            }).$promise)
            .then(() => {
                this.$state.go('^.^', {}, {reload: '^.^'});
                this.Alert('success', 'company.sharing-center.manage.removed');
            })
            .finally(() => this.isRemoving = false)
    }

    save() {
        this.isSaving = true;
        this.SharedAccountsService.updateCompanyServiceAccounts(
            {
                companyId: this.companyId, //resolve.companyId,
                publicServiceId: this.account.publicService.id,
            },
            {
                id: this.account.id,
                username: this.account.username,
                password: this.account.password,
                serviceLoginUrl: this.account.serviceLoginUrl,
                enabled2fa: true,
                showOtpEnabled: this.account.showOtpEnabled,
                showPasswordEnabled: this.account.showPasswordEnabled,
                showNoteEnabled: this.account.showNoteEnabled,
                note: this.account.note,
                customServiceName: this.account.customServiceName,
                publicServiceKey: generatePublicServiceKey(
                    this.account.publicService.serviceName,
                    this.account.username,
                    this.account.secret,
                    this.account.digits,
                    this.account.algorithm,
                ),
            }
        )
            .$promise
            .then(account => {
                //this.close({$value: account});
                this.$state.go('^.^', {}, { reload: '^.^' });
                this.Alert('success', 'company.sharing-center.manage.saved');
            })
            .finally(() => this.isSaving = false)
    }

    saveDisabled(form) {
        return this.isSaving || form.$invalid || this.notModified();
    }
    convertDisabled(form){
		return this.isSaving || form.$invalid || this.isRemoving;
	}
    convert() {
        this.isRemoving = true;
        this.ConfirmConvertModal('company.sharing-center.manage.convert-auth-to-pass')
            .then(() => this.SharedAccountsService.convertCompanyServiceAccountToPass(
            {
                companyId: this.companyId, //resolve.companyId,
                publicServiceId: this.account.publicService.id,
            },
            {
                id: this.account.id,
                username: this.account.username,
                password: this.account.password,
                serviceLoginUrl: this.account.serviceLoginUrl,
                enabled2fa: false,
                showOtpEnabled: false,
                showPasswordEnabled: this.account.showPasswordEnabled,
                showNoteEnabled: this.account.showNoteEnabled,
                note: this.account.note,
                customServiceName: this.account.customServiceName,
                publicServiceKey: null,
            }
        )
            .$promise)
            .then(() => {
                this.$state.go('company.sharing-center.shared-passwords');
                this.Alert('success', 'company.sharing-center.manage.saved');
            })
            .finally(() => this.isRemoving = false)
    }
}

function generatePublicServiceKey(issuer, username, secretKey, digits, algorithm) {
    const secret = secretKey.replace(/\s/g, '');
    return `otpauth://totp/${issuer}:${username}?secret=${secret}&issuer=${issuer}&digits=${digits}&algorithm=${algorithm}`;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/manage/manage-shared-authenticator.controller.js